var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelSchedule(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.057,
    height: 15.057,
    viewBox: "0 0 15.057 15.057",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15764.002 -12730.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M362.069,210.836a.343.343,0,0,1,0,.483l-1.209,1.209,1.209,1.209a.342.342,0,0,1-.483.483l-1.209-1.209-1.209,1.209a.342.342,0,0,1-.483-.483l1.209-1.209-1.209-1.209a.342.342,0,0,1,.483-.483l1.209,1.209,1.209-1.209a.343.343,0,0,1,.483,0ZM355.717,205a.717.717,0,1,1-.507.21A.717.717,0,0,1,355.717,205Zm2.151,0a.717.717,0,1,1-.507.21A.717.717,0,0,1,357.868,205Z",
    transform: "translate(-16116.85 12528.151)",
    fill: "#0c4767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.075,202.717a.358.358,0,0,0-.359.358v11.472a1.792,1.792,0,0,0,1.792,1.792h10.038a1.792,1.792,0,0,0,1.792-1.792V203.075a.358.358,0,0,0-.358-.358Zm0-.717h12.906a1.075,1.075,0,0,1,1.075,1.075v11.472a2.509,2.509,0,0,1-2.509,2.509H354.509A2.509,2.509,0,0,1,352,214.547V203.075A1.075,1.075,0,0,1,353.075,202Z",
    transform: "translate(-16116.002 12528.999)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,208.717V208h15.057v.717Z",
    transform: "translate(-16116.002 12527.302)",
    fill: "#0d3b66"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelSchedule);
export default __webpack_public_path__ + "static/media/cancel_schedule.c8d08150b87a9067a6cb5650660174bb.svg";
export { ForwardRef as ReactComponent };